export default __webpack_public_path__ + "static/media/left-arrow.a5a192a6.svg";